import cx from "classnames";
import dynamic from "next/dynamic";
import { memo } from "react";

import type { IListComponentProps } from "../../types";
import type { GridResponsiveConfig } from "./types";
import {
  DEFAULT_COLS_BY_TYPE,
  DEFAULT_GAPS_BY_TYPE,
  getDefaultForCellType,
  resolveResponsiveProp,
} from "./utils";

import styles from "./GridComponent.module.scss";

const ListComponentItem = dynamic(
  () =>
    import(
      "components/Configuration/ListComponent/components/ListComponentItem/components/ListComponentItem"
    )
);

export interface GridComponentProps extends IListComponentProps {
  className?: string;
  responsive?: GridResponsiveConfig;
}

export const GridComponent = memo(
  ({ className, responsive, component, loading }: GridComponentProps) => {
    const cols = resolveResponsiveProp(
      responsive,
      "cols",
      getDefaultForCellType(DEFAULT_COLS_BY_TYPE, component.CellType)
    );
    const gaps = resolveResponsiveProp(
      responsive,
      "gap",
      getDefaultForCellType(DEFAULT_GAPS_BY_TYPE, component.CellType)
    );

    const entities = component.MediaList;

    return (
      <div
        className={cx(styles.grid, className)}
        style={
          {
            "--cols": cols.phone,
            "--cols-tablet": cols.tablet,
            "--cols-desktop": cols.desktop,
            "--cols-large": cols.large,

            "--gap": gaps.phone,
            "--gap-tablet": gaps.tablet,
            "--gap-desktop": gaps.desktop,
            "--gap-large": gaps.large,
          } as React.CSSProperties
        }
      >
        {entities?.map((media) => (
          <ListComponentItem
            key={media.Id}
            media={media}
            cellType={component.CellType}
            cutomListItem={component.CutomListItem}
            isPlaceholder={!!loading}
            readOnly={loading}
            query={component.QueryParams}
            renderSSR={true}
          />
        ))}
      </div>
    );
  }
);

export default GridComponent;
